import { TWinterCategoryType } from "../entitys/winter";
import { WinterCategoryType } from "../enums";

export const WinterCategoryList: TWinterCategoryType[] = [
  { name: "Winter Wonderland", type: WinterCategoryType.WinterWonderland },
  {
    name: "Winter Products Category",
    type: WinterCategoryType.Category,
  },
  { name: "More Winter Products", type: WinterCategoryType.More },
];
